import React, { Fragment, useState } from "react"
import { GenericDialog } from "../../../components/generic/GenericDialog"
import { Interests } from "../../../components/ui/profileSetup/bio/Interests";
import { GenericTextArea } from "../../../components/generic/GenericTextFields";
import { Box, Button, Stack, Typography } from "@mui/material";
import { GenericCircleIcon } from "../../../components/generic/GenericCircleIcon";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { NeedHelp } from "../../../components/ui/topbar/generic/GenericDialogFooter";
import { createCollabRequest } from "../../../config/apisauce";
import LoadingButton from "@mui/lab/LoadingButton";
import { PENDING } from "../../../enums/statusEnums";

export const CollabRequestDialog = ({ openRequestCollabDialog, handleCloseRequestCollabDialog, isCollabForm, setIsCollabForm, creatorDetails }) => {
  const [collabInterestSelected, setCollabInterestSelected] = useState({});
  const [contentInterestSelected, setContentInterestSelected] = useState({});
  const [details, setDetails] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClearForm = () => {
    setCollabInterestSelected({});
    setContentInterestSelected({});
    setDetails('');
    handleCloseRequestCollabDialog();
  };

  const handleSubmitRequest = async () => {
    setLoading(true);
    const params = {
      status: PENDING,
      user_id: creatorDetails?.id,
      email: creatorDetails?.email,
      name: creatorDetails?.name,
      details: details,
      collaborate_interest_sfw: collabInterestSelected?.sfw,
      collaborate_interest_nsfw: collabInterestSelected?.nsfw,
      content_interest_sfw: contentInterestSelected?.sfw,
      content_interest_nsfw: contentInterestSelected?.nsfw
    };
    const response = await createCollabRequest(params);
    if (response.ok) {
      setIsCollabForm(false);
    }
    setLoading(false);
  };

  return (
    <GenericDialog
      width={isCollabForm ? '854px' : '500px'}
      maxWidth={'sm'}
      title={isCollabForm ? 'Collab Details' : 'Invitation Sent!'}
      openDialog={openRequestCollabDialog}
      handleClose={handleCloseRequestCollabDialog}
    >
      {
        isCollabForm ? <Fragment>
          <Box sx={{ overflowX: 'auto', height: { sm: '90vh', md: '100%' } }}>
            <Interests
              storeKey={'name'}
              collabTitle={'Which collab interests would you like to collaborate on?'}
              contentTitle={'Which content interests would you like to collaborate on?'}
              collabInterestSelectedIds={collabInterestSelected}
              contentInterestSelectedIds={contentInterestSelected}
              setCollabInterestSelectedIds={setCollabInterestSelected}
              setContentInterestSelectedIds={setContentInterestSelected}
              separateCategory={true}
            />
            <GenericTextArea
              isRequired={true}
              value={details}
              labelVariant={'subtitle1'}
              mt={2.5}
              label={'Please provide more details about the collab you have in mind:'}
              handleChange={(value) => setDetails(value)}
            />
          </Box>
          <Stack direction={'row'} mt={3} gap={1} justifyContent={'flex-end'}>
            <Button variant="outlined" sx={{ width: '250px' }} onClick={() => handleCloseRequestCollabDialog()}>Cancel</Button>
            <LoadingButton
              onClick={() => handleSubmitRequest()}
              loading={loading}
              variant="contained"
              disabled={loading}
              sx={{ width: '250px' }}
            >
              Request
            </LoadingButton>
          </Stack>
        </Fragment> : <Stack gap={2} alignItems={'center'}>
          <GenericCircleIcon color={'primary.main'}>
            <EnvelopeSimple size={96} weight="thin" />
          </GenericCircleIcon>
          <Typography variant="subtitle1" textAlign={'center'}>
            Your collab invitation has been sent via email! We’ll notify you once the creator responds. Thank you for reaching out!
          </Typography>
          <Button variant="contained" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => handleClearForm()}>Got it!</Button>
          <NeedHelp />
        </Stack>
      }
    </GenericDialog>
  )
};